import moment from 'moment';

export function getLastReviewedInNUAR (assetHeaderSection, assetSectionProperties) {
    let lastReviewedInNUAR = null;
    if (Array.isArray(assetHeaderSection) && assetHeaderSection.length > 0) {
        const attributes = assetHeaderSection[0].attributes;
        if (Array.isArray(attributes)) {
            const lastReview = attributes.find(attr => attr?.displayName && attr?.displayName.en === 'Last reviewed in NUAR');
            if (lastReview) {
                lastReviewedInNUAR = lastReview.value;
            }
        }
    }
    if (!lastReviewedInNUAR && assetSectionProperties) {
        lastReviewedInNUAR = assetSectionProperties
            .find(section => section?.displayName.en === 'Data currency')
            ?.attributes.find(attribute => attribute?.displayName.en === 'Last reviewed in NUAR')
            ?.value;
    }
    return lastReviewedInNUAR;
}

export function getIntlKeyIfOutOfDate (lastReviewedInNUAR, expectedRefreshPeriod, expectedRefreshUnits) {
    if (!lastReviewedInNUAR || !expectedRefreshPeriod || !expectedRefreshUnits) {
        return '';
    }
    let intlKey = '';
    const [datePart] = lastReviewedInNUAR.split(',');
    const [day, month, year] = datePart.split('/').map(Number);
    const lastReviewedDate = new Date(year, month - 1, day);
    const expectedRefreshDate = moment().subtract(expectedRefreshPeriod, expectedRefreshUnits);
    if (lastReviewedDate < expectedRefreshDate) {
        intlKey = 'selectFeaturePanel.tab.outOfDate';
    }
    return intlKey;
}

export function getDataRefreshStatus (lastReviewedInNUAR, expectedRefreshPeriod, expectedRefreshUnits) {
    if (!lastReviewedInNUAR || !expectedRefreshPeriod || !expectedRefreshUnits) {
        return null;
    }

    const [datePart] = lastReviewedInNUAR.split(',');
    const [day, month, year] = datePart.split('/').map(Number);
    const lastReviewedDate = moment([year, month - 1, day]);
    const expectedRefreshDate = moment().subtract(expectedRefreshPeriod, expectedRefreshUnits);

    if (lastReviewedDate.isBefore(expectedRefreshDate)) {
        // Data is out of date
        const daysOverdue = moment().diff(lastReviewedDate.add(expectedRefreshPeriod, expectedRefreshUnits), 'days');
        return {
            isOutOfDate: true,
            daysOverdue: daysOverdue > 0 ? daysOverdue : 0
        };
    }

    // Data is within expected refresh rate
    return {
        isOutOfDate: false,
        daysOverdue: 0
    };
}
